module.exports = __webpack_public_path__ + "static/media/25488462_1703509276390923_9107641513322904378_o.073c8de6.jpg";